import { YellowCircle } from "components/BulletList/BulletCharacters";
import Box from 'components/Containers/Box';
import RowBox from 'components/Containers/RowBox';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import CenterAlignBox from 'components/Containers/CenterAlignBox';
import SpreadBox from 'components/Containers/SpreadBox';
import DisclaimerPortal from 'components/Disclaimer/DisclaimerPortal';
import Label from 'components/form/Label/Label';
import OText from 'components/CText/OText';
import { Bullet, BulletList } from 'components/BulletList';
import PIcon from 'components/personalization/PIcon';
import { Button } from 'components/form/Button';
import React from 'react';

const AccumulateSegmentCashPromotionView = props => {
  return (
    <>
      <SectionContainer id="webBoosterPromo" datatestid="webboosterpromo">
        {props?.seenPixel}
        <Row className="margB16">
          <SpreadBox>
            <Box widthClassName="format60 m-format100">
              <CenterAlignBox className="d-hide padB16">
                <PIcon icon={props?.img} />
              </CenterAlignBox>
              <Label className="padB16" type="H3 mH5">
                <OText text={props?.title} />
              </Label>
              <div className="padB32 m-padB24">
                <OText text={props?.paragraph} />
              </div>
              {props?.bullets?.length > 0 && (
                <BulletList paddingLeftClass="padL0" className="padB40">
                  {props?.bullets?.map((text, k) => {
                    return (
                      <Bullet
                        bulletCharacter={<YellowCircle/>}
                        className="margB8 "
                      >
                        <OText text={text} />
                      </Bullet>
                    );
                  })}
                </BulletList>
              )}
              <Button mrphType="primary" onClick={props?.onCtaClick}>
                <div className="padLR60">
                  {' '}
                  <OText text={props?.ctaText} />
                </div>
              </Button>
            </Box>
            <RowBox
              className="height100 t-hide m-hide justify-start"
              widthClassName="format40"
              alignItemsEnd
            >
              <PIcon icon={props?.img} />
            </RowBox>
          </SpreadBox>
        </Row>
      </SectionContainer>
      <DisclaimerPortal>
        <OText text={props.disclaimer} />
      </DisclaimerPortal>
    </>
  );
};

export default AccumulateSegmentCashPromotionView;
